import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { isValidIIN } from '@aviata/iin';

dayjs.extend(customParseFormat);

/** ИИН — ровно 12 цифр. */
export const IIN_LENGTH = 12;

/**
 * @description The 7th digit in IIN always tells the century in which person was born
 *
 * @see https://yvision.kz/post/iin-algoritm-rascheta-i-proverki-114938
 */
const IIN_BORN_CENTURY = {
  twentieth: [3, 4],
  twentyFirst: [5, 6],
};

/**
 * Первые шесть цифр ИИН — дата рождения (ГГММДД), век задаёт седьмая цифра.
 * Проверяем, что такая дата существует: контрольная сумма сама этого не ловит,
 * и «13-й месяц» проходил бы как валидный ИИН.
 */
export const isValidIinDate = (iin: string): boolean => {
  const datePart = iin.slice(0, 6);

  if (!/^\d{6}$/.test(datePart)) {
    return false;
  }

  const year = parseInt(iin.slice(0, 2), 10);
  const month = iin.slice(2, 4);
  const day = iin.slice(4, 6);
  const bornInCenturyId = parseInt(iin.slice(6, 7), 10);

  let fullYear = 2000 + year;

  // year 2000 is in 20th century, so we skip it
  if (year !== 0 && IIN_BORN_CENTURY.twentieth.includes(bornInCenturyId)) {
    fullYear = 1900 + year;
  }

  const parsed = dayjs(`${fullYear}-${month}-${day}`, 'YYYY-MM-DD', true);

  return parsed.isValid();
};

/**
 * Полная проверка ИИН: контрольная сумма (`@aviata/iin`) плюс существующая дата
 * рождения в первых шести цифрах.
 *
 * Ровно эта пара проверок стоит в форме брони (`getBaseValidations`) — вынесена
 * отдельно, чтобы формы без vuelidate (например, форма пассажира в ИИ-чате)
 * валидировали ИИН так же, а не «12 цифр — и достаточно».
 * Длину здесь не проверяем: она — отдельное сообщение об ошибке в формах.
 */
export const isValidIin = (iin: string): boolean =>
  isValidIIN(iin) && isValidIinDate(iin);
